import { render, staticRenderFns } from "./PuzzleTermList.vue?vue&type=template&id=92365c50&"
import script from "./PuzzleTermList.vue?vue&type=script&lang=js&"
export * from "./PuzzleTermList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports